import { mainUrl, client } from '../app-constants';

export function getPianoTechAppointmentList() {
    const url = mainUrl + 'pt.appt/listPianoTechAppointment'

    return client.get(url);
}

export function getPianoTechAppointmentListForCompanyFromDate(companyId, startingDate) {
    const url = mainUrl + 'pt.appt/listPianoTechAppointmentByCompanyFromDate?companyId=' + companyId + '&startingDate=' + startingDate;

    return client.get(url);
}

export function findPianoTechAppointment(appointmentId) {
    const url = mainUrl + 'pt.appt/findPianoTechAppointment?appointmentId=' + appointmentId;

    return client.get(url);
}

export function savePianoTechAppointment(pianoTechAppointment) {
    const url = mainUrl + 'pt.appt/savePianoTechAppointment';

    return client.post(url, pianoTechAppointment);
}

